import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { msalConfig, API_SCOPE } from './auth-config';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';

/**
 * Factory function to create MSAL instance
 * Configures browser-specific settings and cache location
 */
export function MSALInstanceFactory(platformId: Object): IPublicClientApplication {
  const isLocalEnvironment = environment.envName.toLowerCase() === 'dev';
  
  const commonConfig = {
    auth: {
      ...msalConfig.auth,
      redirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    },
    cache: {
      cacheLocation: isPlatformBrowser(platformId) ? BrowserCacheLocation.LocalStorage : BrowserCacheLocation.MemoryStorage,
      storeAuthStateInCookie: true,
      secureCookies: !isLocalEnvironment
    },
    system: {
      loggerOptions: {
        logLevel: isLocalEnvironment ? LogLevel.Info : LogLevel.Error,
        piiLoggingEnabled: false
      },
      windowHashTimeout: 9000,
      iframeHashTimeout: 9000,
      loadFrameTimeout: 9000
    }
  };

  return new PublicClientApplication(commonConfig);
}

/**
 * Factory function for MSAL Guard configuration
 * Configures authentication interaction type and required scopes
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [
        API_SCOPE
      ],
      claims: JSON.stringify({
        access_token: {
          roles: { essential: true }
        },
        id_token: {
          roles: { essential: true }
        }
      })
    },
    loginFailedRoute: '/'
  };
}

/**
 * Factory function for MSAL Interceptor configuration
 * Note: Empty protected resource map - all API authentication is handled by Kong Gateway
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map<string, Array<string>>()
  };
}
